import { render } from "./TransactionCorrectionRequest.vue?vue&type=template&id=f4cd85d2&scoped=true"
import script from "./TransactionCorrectionRequest.vue?vue&type=script&lang=js"
export * from "./TransactionCorrectionRequest.vue?vue&type=script&lang=js"

import "./TransactionCorrectionRequest.vue?vue&type=style&index=0&id=f4cd85d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4cd85d2"]])

export default __exports__